<template>
  <div class="page-add">
    <div class="add-title">{{ !editId ? "新增请假" : "编辑请假" }}</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="120px"
      :rules="rules"
      :model="classForm"
      ref="classForm"
    >
      <el-row>
        <el-col :span="this.classParentId ? 9:12">
          <el-form-item label="班级名称：" prop="className">
            <el-input
              style="width: 100%"
              :disabled="true"
              v-model="className"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-if="this.classParentId">
          <el-form-item v-if="editId" class="period_form">
            <el-input
              :disabled="true"
              v-model="classForm.periodName"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-else prop="bizId" class="period_form">
            <el-select
              class="form-select"
              v-model="classForm.bizId"
              placeholder="请选择期次"
              @change="changeBizId"
            >
              <el-option
                v-for="item in relationClassData"
                :key="item.uuid"
                :label="item.className"
                :value="item.uuid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="学员：" prop="userId">
            <load-select
              class="form-select"
              v-model="classForm.userId"
              dictLabel="userName"
              dictValue="userId"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getData"
              @change="setChange"
              :disabled="!!editId"
              :defaultVal="classForm.userName"
              placeholder="请选择学员（输入学员名称关键字以查询）"
              :isInit="isSetInit"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="请假类型：" prop="leaveType">
            <el-select
              class="form-select"
              v-model="classForm.leaveType"
              placeholder="请选择请假类型"
            >
              <el-option
                v-for="item in leaveTypeData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6"
          ><el-form-item
            label="开始时间："
            prop="startDay"
            :rules="[
              {
                required: true,
                validator: checkStartDay,
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              v-model="classForm.startDay"
              type="date"
              clearable
              placeholder="开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="checkTime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="startDayType" class="period_form">
            <el-select
              class="form-select"
              v-model="classForm.startDayType"
              placeholder="请选择时间"
              @change="checkTime"
            >
              <el-option
                v-for="item in dayTimeData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="classForm.leaveType !== 3">
        <el-col :span="6"
          ><el-form-item
            label="结束时间："
            prop="endDay"
            :rules="[
              {
                required: true,
                validator: checkEndDay,
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              v-model="classForm.endDay"
              type="date"
              clearable
              placeholder="结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="checkTime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="endDayType" class="period_form">
            <el-select
              class="form-select"
              v-model="classForm.endDayType"
              placeholder="请选择时间"
              @change="checkTime"
            >
              <el-option
                v-for="item in dayTimeData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="时长(天)："
            prop="leaveDays"
          >
            <el-input
              v-model="classForm.leaveDays"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              @input="limitInput"
              placeholder="请输入时长"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="申请事由："
            prop="auditNotes"
          >
            <el-input
              type="textarea"
              rows="4"
              v-model="classForm.auditNotes"
              placeholder="请输入申请事由"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            class="scale"
            label="证明材料："
            prop="attachmentList"
            :rules="[
            {
              required: true,
              message: '请上传证明材料',
              trigger: ['change'],
            },
          ]"
          >
            <upload
              :limit="1"
              :path="'enrollment/attachment'"
              v-model="classForm.attachmentList"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="审核人："
            prop="auditUserIds"
          >
            <el-select
              v-model="classForm.auditUserIds"
              class="select"
              multiple
              placeholder="请选择审核人"
              style="width: 64%"
              filterable
            >
              <el-option
                v-for="item in auditUserList"
                :key="item.userId"
                :label="item.userName"
                :value="String(item.userId)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <back-button :floatLeft="false"/>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { queryEnroll, queryAuditUser, getRelationClass, saveLeaveAudit, getLeaveAuditInfo, getLeaveDays } from "@/api/enrollment";
import LoadSelect from "@/components/load-select/index.vue";
import { getSysParamByTypes } from "@/api/sysParam";
import moment from "moment";
import Upload from "@/components/upload/index";
import rulesFactory from "@/utils/rules";
import { setItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index";

export default {
  name: "leaveAdd",
  components: { Upload, BackButton, LoadSelect },
  data() {
    return {
      more: true,
      page: 1,
      data: [],
      editId: null, // 编辑
      bizId: null, // 非轮训班-新增
      classParentId: null, // 轮训班-新增
      className: "",
      rulesFactory,
      dayTimeData: [],
      leaveTypeData: [],
      relationClassData: [],
      auditUserList: [],
      classForm: {
        leaveType: 0,
        className: "",
        userName: "",
        attachmentList: [],
      },
      rules: {
        userId: [rulesFactory.required("请选择学员")],
        leaveType: [rulesFactory.required("请选择请假类型")],
        startDayType: [rulesFactory.required("请选择时间")],
        endDayType: [rulesFactory.required("请选择时间")],
        leaveDays: { required: true, message: "请输入时长", trigger: ["blur", "change"] },
        auditNotes: [
          rulesFactory.required('请输入申请事由'),
          rulesFactory.size('最多输入500个字', 0, 500),
        ],
        auditUserIds: [
          rulesFactory.required('请选择审核人')
        ],
        // attachmentList: [rulesFactory.required("请上传证明材料")],
      },
      isSetInit: true,
      classInfo: {}
    };
  },
  created() {
    this.editId = this.$route.query.id;
    this.bizId = this.$route.query.classId;
    this.classParentId = this.$route.query.classParentId;
    this.className = this.$route.query.className || this.$route.query.classParentName;
    if (this.editId) {
      // 编辑
      getLeaveAuditInfo(this.editId).then((res) => {
        if (!res || res.code != 0) return;
        let obj = Object.assign({}, res.data);
        this.bizId = obj.bizId;
        this.getCanAudit({ classId: this.bizId }, false);

        if (obj.attachment) {
          obj.attachmentList = JSON.parse(obj.attachment);
        } else {
          obj.attachmentList = [];
        }
        this.classForm = obj;
        this.loadFlag = true;
      });
    } else {
      // 新增
      this.loadFlag = true; 
      this.addInfoDto();
      // 新增:（非轮训班-直接获取报名审核人；轮训班选完期次后获取)；编辑：获取详情后获取
      if (this.bizId) {
        this.getCanAudit({ classId: this.bizId }, false);
      }
      if (this.classParentId) {
        this.getRelationClass();
      };
    }
    this.getSysParamByTypes([
      "LEAVE_TYPE",
      "DATE_AM_PM"
    ]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.leaveTypeData = res.data["LEAVE_TYPE"];
        // if (this.leaveTypeData.length > 0 && !this.edit) {
        //   // 设置默认选中
        //   this.classForm.leaveType = Number(this.leaveTypeData[0].paramKey);
        // } 
        // const dateList = res.data["DATE_AM_PM"] || []
        // let newDateList = []
        // for (let i = 0; i < dateList.length; i++) {
        //   const item = dateList[i];
        //   if (item.paramValue !== '晚上') {
        //     newDateList.push(item);
        //   }
        // }
        // this.dayTimeData = newDateList;
        this.dayTimeData = res.data["DATE_AM_PM"] || [];
      });

        
    },
    getRelationClass() {
      let params = {classParentId: this.classParentId,isNotShow: 1};
      getRelationClass(params).then(({ code, data }) => {
        if (code !== 0) return;
        this.relationClassData = data;
      })
    },
    // 获取请假天数
    getLeaveDays() {
      let params = {
        startDay: this.classForm.startDay,
        startDayType: this.classForm.startDayType,
        leaveType: this.classForm.leaveType,
      };
      if (this.classForm.leaveType !== 3) {
        params.endDay = this.classForm.endDay;
        params.endDayType = this.classForm.endDayType;
      } else {
        // 请假类型：退学
        params.classId = this.bizId;
      }
      getLeaveDays(params).then((res) => {
        if (res.code !== 0) return;
        this.classForm.leaveDays = res.data;
      })
    },
    // 新增调用-修改期次
    changeBizId(val) {
      this.bizId = val;
      this.getCanAudit({ classId: this.bizId }, false);
      this.isSetInit = true;
      this.page = 1;
      this.data = [];
      this.more = true;
    },
    // 下拉加载
    setChange() {
      this.isSetInit = false;
    },
    // 下拉加载学员
    getData({ page = 1, more = false, keyword = "" } = {}) {
      if (!this.classForm.bizId) {
        this.$message({
          message: "请先选择期次！",
          type: "error",
        });
        return;
      }
      return new Promise((resolve) => {
        queryEnroll({ page, userName: keyword, classId: this.bizId }).then(({ code, data }) => {
          if (code !== 0) return;
          if (more) {
            this.data = [...this.data, ...data.records];
          } else {
            this.data = data.records;
          }
          this.page = data.current;
          let { current, total, size } = data;
          this.more = current * size < total;
          this.page = current;
          resolve();
        });
      });
    },
    // 审核人
    getCanAudit(params, flag) {
      queryAuditUser(params).then((res) => {
        if (!res || res.code != 0) return;
        this.auditUserList = res.data || [];
        if (flag) {
          this.classForm.auditUserIds = [];
        }
      });
    },
    // 校验结束时间
    checkEndDay(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error("请选择结束时间"));
      } else if (moment(value) < moment(this.classForm.startDay)) {
        callback(new Error("结束时间必须晚于开始时间"));
      } else {
        callback();
      }
    },
    // 校验开始时间
    checkStartDay(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error("请选择开始时间"));
      } else if (this.classForm.leaveType !== 3 && moment(value) > moment(this.classForm.endDay)) {
        callback(new Error("开始时间必须早于结束时间"));
      } else {
        callback();
      }
    },
    // 初始化当前数据
    addInfoDto() {
      this.classForm = {
        bizId: this.bizId, // 班级ID
        className: this.className,
        userId: "",
        attachment: "",
        auditNotes: "",
        auditUserIds: [],
        endDay: "",
        endDayType: '',
        leaveDays: "",
        leaveType: "",
        startDay: "",
        startDayType: '',
      };
    },
    //新增请假
    submit() {
      this.$refs["classForm"].validate().then(() => {
        let params = Object.assign({}, this.classForm);
        let rawData = this.classForm;

        if (rawData.attachmentList && rawData.attachmentList.length > 0) {
          params["attachment"] = JSON.stringify(rawData.attachmentList);
        } else {
          // 请假类型为公假、退学，证明材料必填；请假类型为事假和病假，证明材料选填。
          if (Number(params.leaveType) == 2 || Number(params.leaveType) == 3) {
            this.$message({
              message: "请上传证明材料！",
              type: "error",
            });
            return;
          }
          params["attachment"] = null;
        }
        if (this.editId) {
          params.uuid = this.editId;
          delete params.auditUserNames;
        }
        saveLeaveAudit(params).then((res) => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "操作成功！",
            type: "success",
          });
          this.$router.back();
        });
      })
      .catch(() => {});
    },
    // 检验、获取请假时长
    checkTime(val) {
      let startDay = this.classForm.startDay;
      let endDay = this.classForm.endDay;
      let startDayType = this.classForm.startDayType;
      let  endDayType = this.classForm.endDayType;
      if (!val) {
        return;
      } else if (this.classForm.leaveType !== 3 && this.hasValue(startDay, endDay, startDayType, endDayType)) {
        // 请假类型：非退学
        return;
      } else if (this.classForm.leaveType == 3 && (!startDay || !startDayType )) {
        // 请假类型：退学
        return;
      } else if (startDay == endDay && endDayType < startDayType) {
        this.classForm.startDayType = "";
        this.classForm.endDayType = "";
        return this.$message({
          message: "结束时间必须晚于开始时间！",
          type: "error",
        });
      } else {
        this.getLeaveDays();
      }
    },
    hasValue(val1, val2, val3, val4) {
      if (!val1 || !val2 || !val3 || !val4) {
        return true;
      } else return false;
    },
    limitInput(value) {
      if (Number(value) < 0) {
        return this.classForm.leaveDays = 0;
      }
      if (value != "") {
        if (value.indexOf(".") > -1) {
          this.classForm.leaveDays = value.slice(0, value.indexOf(".") + 2);
        } else {
          this.classForm.leaveDays = value;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
/deep/ .period_form .el-form-item__content {
  margin-left: 16px !important;
}
/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}
/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}
.form-select {
  width: 100%;
}
/deep/ .el-form-item__content {
  .form-dept {
    width: calc(50% - 139px);
    font-size: inherit;
  }
  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }
  .el-select.select {
    width: 100% !important;
  }
}
.upload-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: $textColor;
  font-size: 13px;
}
.year_style {
  width: 100px;
  margin-right: 10px;
  color: #51627d;
}
.upload_tip {
  width: 280px;
  text-align: center;
  margin-top: 10px;
}
.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}
.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
.className-style {
  width: calc(100% - 110px);
}
/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}
.form-text-center {
  text-align: center !important;
}
.input {
  width: 150px !important;
}
</style>
